import helper from "../helper";

let getPassOrderUrl = helper.getPassOrderUrlWithParameters
let getPassOrderAllowed = helper.allowedPassOrderUrl

export default {
    getPassOrderUrl,
    getByRecievedUrlData: (url, gets = null) => getPassOrderUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    VIEWER: {
        ALLOWED: () => getPassOrderAllowed(
            "observer|orders|orders-list",
            "list"
        ),
        FILE: {
            UNLOADING:
                (gets = null) => getPassOrderUrl(
                    "observer|orders|orders-need-unloading",
                    "need_unloading",
                    {},
                    gets
                )
        },
        VISITORS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "observer|references|visitors-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "observer|references|visitors-detail",
                    "retrieve",
                    {id: id},
                    gets
                )
        },
        ORDERS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "observer|orders|orders-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "observer|orders|orders-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            ADDITIONAL:{
                LIST:
                    (order_number, gets = null) => getPassOrderUrl(
                        "observer|orders|additional-list",
                        "list",
                        {order_number: order_number},
                        gets
                    ),
                DETAIL:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "observer|orders|additional-detail",
                        "retrieve",
                        {order_number: order_number, id: id},
                        gets
                    )
            },
            VISITORS: {
                LIST:
                    (order_number, gets = null) => getPassOrderUrl(
                        "observer|orders|visitors-list",
                        "list",
                        {order_number: order_number},
                        gets
                    ),
                DETAIL:
                    (order_number, id, gets = null) => getPassOrderUrl(
                        "observer|orders|visitors-detail",
                        "retrieve",
                        {order_number: order_number, id: id},
                        gets
                    )
            }
        },
        FIELDS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "observer|orders|fields-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "observer|orders|fields-detail",
                    "retrieve",
                    {id: id},
                    gets
                )
        },
        CARS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "observer|references|cars-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "observer|references|cars-detail",
                    "retrieve",
                    {id: id},
                    gets
                )
        },
        UID_USER:{
            CARS: {
                LIST:
                    (user_uid, gets = null) => getPassOrderUrl(
                        "observer|references|user|cars-list",
                        "list",
                        {user_uid: user_uid},
                        gets
                    ),
                DETAIL:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "observer|references|user|cars-detail",
                        "retrieve",
                        {user_uid: user_uid, id: id},
                        gets
                    )
            },
            VISITORS: {
                LIST:
                    (user_uid, gets = null) => getPassOrderUrl(
                        "observer|references|user|visitors-list",
                        "list",
                        {user_uid: user_uid},
                        gets
                    ),
                DETAIL:
                    (user_uid, id, gets = null) => getPassOrderUrl(
                        "observer|references|user|visitors-detail",
                        "retrieve",
                        {user_uid: user_uid, id: id},
                        gets
                    )
            }
        },
        ORGANIZATIONS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "observer|references|organizations-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "observer|references|organization-detail",
                    "retrieve",
                    {id: id},
                    gets
                )
        }
    }
}
